function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Transparent back mobile");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "75.9987199%",
  y1: "93.351173%",
  x2: "50%",
  y2: "-22.7036258%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#53A0FD",
  offset: "58.638909%"
}), React.createElement("stop", {
  stopColor: "#C9F3F5",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "63.8607629%",
  y1: "93.7810635%",
  x2: "79.4675915%",
  y2: "-17.3061585%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#3023AE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#53A0FD",
  offset: "58.638909%"
}), React.createElement("stop", {
  stopColor: "#C9F3F5",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Transparent-back-mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Dark-Background-Mark",
  transform: "translate(13.000000, 12.000000)"
}, React.createElement("g", {
  id: "Group-3-Copy"
}, React.createElement("path", {
  d: "M19.4846926,19.0495536 C22.9555301,17.5442378 25.3843859,14.0761819 25.3840964,10.0382657 C25.3837082,4.61923786 21.0084313,0.225933077 15.611642,0.225544785 C11.5969321,0.22525593 8.14787322,2.65607876 6.64477319,6.13201729 C12.0582388,4.13038327 16.3076557,6.61978373 18.3273982,9.41933709 C20.3471408,12.2188905 20.7706211,15.6712672 19.4846926,19.0495536 Z",
  id: "Oval",
  fill: "url(#linearGradient-1)",
  transform: "translate(16.014435, 9.637549) rotate(1.000000) translate(-16.014435, -9.637549) "
}), React.createElement("path", {
  d: "M13.351698,23.940175 C16.8367174,22.4412815 19.2753254,18.9876199 19.2747471,14.9662593 C19.273971,9.56944968 14.8803683,5.19384191 9.46136079,5.19306579 C5.43012256,5.19248844 1.96703744,7.61309593 0.45799702,11.0746745 C5.89360675,9.08163789 10.1606956,11.5611383 12.1889528,14.3493592 C14.21721,17.13758 14.6426799,20.5758324 13.351698,23.940175 Z",
  id: "Oval-Copy-4",
  fill: "url(#linearGradient-2)",
  transform: "translate(9.866372, 14.566620) rotate(-92.000000) translate(-9.866372, -14.566620) "
}), React.createElement("path", {
  d: "M18.5985133,29.7865804 C22.0694544,28.2810128 24.4985555,24.8127777 24.4985555,20.7748565 C24.4985555,15.355822 20.1235989,10.9628265 14.7268164,10.9628265 C10.7121114,10.9628265 7.26288271,13.3939005 5.75953551,16.8699515 C11.1731378,14.8679255 15.4223709,17.3570234 17.4419104,20.1564349 C19.4614498,22.9558465 19.8846823,26.4081971 18.5985133,29.7865804 Z",
  id: "Oval-Copy-6",
  fill: "url(#linearGradient-2)",
  transform: "translate(15.129045, 20.374703) rotate(-180.000000) translate(-15.129045, -20.374703) "
}), React.createElement("path", {
  d: "M24.764124,24.8717084 C28.2491434,23.3728146 30.6877512,19.9191532 30.6871731,15.8977926 C30.6863968,10.500983 26.2927941,6.12537521 20.8737867,6.12459912 C16.8425485,6.12402174 13.3794634,8.54462926 11.8704229,12.0062078 C17.3060327,10.0131712 21.5731215,12.4926717 23.6013787,15.2808925 C25.6296359,18.0691133 26.0551058,21.5073657 24.764124,24.8717084 Z",
  id: "Oval-Copy-7",
  fill: "url(#linearGradient-2)",
  transform: "translate(21.278798, 15.498154) rotate(88.000000) translate(-21.278798, -15.498154) "
}))));

var SvgSironaLogo = function SvgSironaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "56px",
    height: "55px",
    viewBox: "0 0 56 55",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSironaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SironaLogo.1d7c7e03.svg";
export { ForwardRef as ReactComponent };